import { gql } from '@apollo/client';

export const SEARCH_USER_PROJECTS = gql`
  query SearchUserProjects($searchInput: SearchInput) {
    searchUserProjects(searchInput: $searchInput) {
      items {
        id
        projectId
        isActive
        firstName
        lastName
        imageUrl
        lobEmployeeId
        persona
        toolHoundId
        user {
          id
          bun
          firstName
          lastName

          roles {
            # stop using role for display purposes, use persona instead
            id
            name
          }
        }
        project {
          id
          jobNumber
          name
          subJobNumber
        }
      }
    }
  }
`;
